import { ApiPropertyOptional } from '@nestjs/swagger'
import { IsOptional, IsString, IsInt, Min, Max } from 'class-validator'
import { Type } from 'class-transformer'

export class UpdateActivityCompetencyLinkDto {
  @ApiPropertyOptional({
    description: 'Niveau cible de la compétence',
    maxLength: 32,
  })
  @IsOptional()
  @IsString()
  targetLevel?: string

  @ApiPropertyOptional({
    description: "Poids de la compétence dans l'activité (1-5)",
    minimum: 1,
    maximum: 5,
  })
  @IsOptional()
  @Type(() => Number)
  @IsInt()
  @Min(1)
  @Max(5)
  weight?: number
}
